angular = require('angular')
require('../../../core/translation/translation-module')
CommonFooterDirective = require('./common-footer-directive')

modules = [
  'gnp-translation'
]
angular.module 'gnp-common-footer', modules
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .directive('gnpCommonFooter', CommonFooterDirective)



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/common-footer/common-footer-module.coffee